export default __webpack_public_path__ + "static/O0125-9f3606d8fb3e5ad6ef991609cf67c522.png";